export const GRID_ITEM = {
  FULL: {
    size: {
      xs: 12,
      sx: {
        padding: '12px',
      },
    },
    LARGE: {
      size: {
        xs: 12,
        sm: 6,
        sx: {
          padding: '12px',
        },
      },
      SMALL: {
        size: {
          xs: 12,
          sm: 6,
          sx: {
            padding: '12px',
          },
        },
      },
    },
  },
}
